<template>
    <form @submit.prevent="handleSubmit" class="sell-car-form">
      
      <div class="form-row">
        <div class="form-group">
          <label for="name">{{ $t('sell_car_form.name') }}:</label>
          <input id="name" v-model="form.name" type="text" :placeholder="$t('sell_car_form.name_placeholder')" required />
        </div>
        <div class="form-group">
          <label for="email">{{ $t('sell_car_form.email') }}:</label>
          <input id="email" v-model="form.email" type="email" :placeholder="$t('sell_car_form.email_placeholder')" required />
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="phone">{{ $t('sell_car_form.phone') }}:</label>
          <input id="phone" v-model="form.phone" type="tel" :placeholder="$t('sell_car_form.phone_placeholder')" />
        </div>
      </div>
      
      <div class="section-title">{{ $t('sell_car_form.car_information') }}</div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="brand">{{ $t('sell_car_form.brand') }}:</label>
          <input id="brand" v-model="form.brand" type="text" :placeholder="$t('sell_car_form.brand_placeholder')" required />
        </div>
        <div class="form-group">
          <label for="model">{{ $t('sell_car_form.model') }}:</label>
          <input id="model" v-model="form.model" type="text" :placeholder="$t('sell_car_form.model_placeholder')" required />
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="year">{{ $t('sell_car_form.year') }}:</label>
          <input id="year" v-model="form.year" type="number" :placeholder="$t('sell_car_form.year_placeholder')" required />
        </div>
        <div class="form-group">
          <label for="mileage">{{ $t('sell_car_form.mileage') }}:</label>
          <input id="mileage" v-model="form.mileage" type="number" :placeholder="$t('sell_car_form.mileage_placeholder')" required />
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="carState">{{ $t('sell_car_form.car_state') }}:</label>
          <select id="carState" v-model="form.car_state" required>
            <option value="" disabled selected>{{ $t('sell_car_form.car_state_placeholder') }}</option>
            <option value="excellent">{{ $t('sell_car_form.car_states.excellent') }}</option>
            <option value="very_good">{{ $t('sell_car_form.car_states.very_good') }}</option>
            <option value="good">{{ $t('sell_car_form.car_states.good') }}</option>
            <option value="fair">{{ $t('sell_car_form.car_states.fair') }}</option>
            <option value="needs_repair">{{ $t('sell_car_form.car_states.needs_repair') }}</option>
          </select>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group full-width">
          <label for="message">{{ $t('sell_car_form.message') }}:</label>
          <textarea id="message" v-model="form.message" :placeholder="$t('sell_car_form.message_placeholder')"></textarea>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group full-width">
          <label for="images">{{ $t('sell_car_form.images') }}:</label>
          <input id="images" type="file" multiple @change="handleFileChange" />
          <small>{{ $t('sell_car_form.images_hint') }}</small>
        </div>
      </div>
    
      <div class="form-actions">
        <button type="button" @click="handleCancel" class="cancel-btn">
          {{ $t('sell_car_form.cancel') }}
        </button>
        <button type="submit" class="submit-btn" :disabled="loading">
          {{ $t('sell_car_form.submit') }}
        </button>
      </div>
    </form>
  </template>
  

<script setup>
import { ref, defineEmits } from 'vue'

const emit = defineEmits(['submit', 'cancel'])

const form = ref({
    name: '',
    email: '',
    phone: '',
    brand: '',
    model: '',
    year: '',
    mileage: '',
    car_state: '',
    message: '',
    images: []
})


const loading = ref(false)

const handleFileChange = (event) => {
    form.value.images = Array.from(event.target.files)
}

const handleSubmit = () => {
    emit('submit', form.value)
    resetForm()
}

const handleCancel = () => {
    emit('cancel')
    resetForm()
}

const resetForm = () => {
    form.value = {
        name: '',
        email: '',
        phone: '',
        brand: '',
        model: '',
        year: '',
        mileage: '',
        car_state: '',
        message: '',
        images: []
    }
}

</script>

 <style scoped>
 .sell-car-form {
   background: #fff;
   padding: 30px;
   border-radius: 12px;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
   display: flex;
   flex-direction: column;
   gap: 20px;
 }
 
 .section-title {
   font-weight: 600;
   font-size: 1.2rem;
   margin-top: 10px;
   color: #333;
   border-bottom: 1px solid #eee;
   padding-bottom: 5px;
 }
 
 .form-row {
   display: flex;
   flex-wrap: wrap;
   gap: 20px;
 }
 
 .form-group {
   flex: 1 1 45%;
   display: flex;
   flex-direction: column;
 }
 
 .full-width {
   flex: 1 1 100%;
 }
 
 label {
   margin-bottom: 5px;
   font-weight: 500;
 }
 
 input,
 select,
 textarea {
   padding: 10px;
   border: 1px solid #ddd;
   border-radius: 6px;
   font-size: 1rem;
 }
 
 textarea {
   min-height: 100px;
   resize: vertical;
 }
 
 small {
   margin-top: 5px;
   font-size: 0.9rem;
   color: #666;
 }
 
 .form-actions {
   display: flex;
   justify-content: flex-end;
   gap: 10px;
   margin-top: 20px;
 }
 
 button {
   padding: 10px 20px;
   border: none;
   border-radius: 6px;
   cursor: pointer;
   font-size: 1rem;
   transition: background-color 0.2s;
 }
 
 button:disabled {
   opacity: 0.7;
   cursor: not-allowed;
 }
 
 .cancel-btn {
   background-color: #f5f5f5;
 }
 
 .cancel-btn:hover {
   background-color: #e0e0e0;
 }
 
 .submit-btn {
   background-color: #0066cc;
   color: white;
 }
 
 .submit-btn:hover:not(:disabled) {
   background-color: #0052a3;
 }
 
 

 @media (max-width: 768px) {
   .form-group {
     flex: 1 1 100%;
   }
 
   .form-actions {
     flex-direction: column;
     align-items: stretch;
   }
 }
 </style>
 